

define(['jquery', 'angular', 'uiRouter'], function ($, angular) {

    angular.module('tracking.directive', ['ui.router']).directive('trackSubmit', function ($state, $rootScope) {
        return {
            restrict: 'AE',
            link: function link($scope, element, attr) {
                element.on('mousedown', function (event) {
                    var transition = attr && attr.trackSubmit;
                    var trackSubmit = {
                        currentRoute: $state.current,
                        transition: transition,
                        errors: []
                    };

                    angular.forEach($('input.ng-invalid, select.ng-invalid'), function (el) {
                        var elem = $(el);
                        var elementId = elem.attr('id');
                        var elementName = elem.attr('name');
                        var errorKey = elem.attr('data-error-key');
                        var errorText = elem.has('required') ? 'required' : 'no error key';
                        var fieldName = elementId ? elementId : elementName;

                        if (!fieldName) {
                            var elementModel = elem.attr('ng-model');
                            fieldName = elementModel ? elementModel : 'unnamed-field';
                        }

                        trackSubmit.errors.push({
                            fieldName: fieldName,
                            errorMessage: errorKey ? errorKey : errorText
                        });
                    });

                    $rootScope.$broadcast('trackSubmit', trackSubmit);
                });
            }
        };
    }).directive('trackLink', function ($state, $rootScope) {
        return {
            restrict: 'AE',
            link: function link($scope, element, attr) {
                element.on('mousedown', function (event) {

                    var state = attr && attr.trackLink;

                    if (state) {
                        var trackLink = {
                            currentRoute: $state.current,
                            transition: state
                        };
                        $rootScope.$broadcast('trackLink', trackLink);
                    }
                });
            }
        };
    }).directive('trackClick', function ($state, $rootScope) {
        return {
            restrict: 'AE',
            link: function link($scope, element, attr) {
                element.on('click', function (event) {
                    var state = attr && attr.trackClick;

                    if (state) {
                        var trackClick = {
                            currentRoute: $state.current,
                            transition: state
                        };
                        $rootScope.$broadcast('trackClick', trackClick);
                    }
                });
            }
        };
    }).directive('trackInput', function ($state, $rootScope) {
        /*
         * Track an input tag with track-input attribute
         * you can use the value of track-input attribute as
         * a tracking attr Eg.: track-input="xo_guest_yes"
         */
        return {
            restrict: 'AE',
            link: function link($scope, element, attr) {
                element.on('click', function (event) {

                    var state;

                    if (event.target.type === 'checkbox') {
                        if (event.target.checked) {
                            state = attr && attr.trackInput + '_CHECKED';
                        } else {
                            state = attr && attr.trackInput + '_UNCHECKED';
                        }
                    } else {
                        state = attr && attr.trackInput;
                    }

                    var trackInput = {
                        currentRoute: $state.current,
                        page: 'main:ec:hermes::fullpage-billing:guest:aries:'
                    };

                    if (state) {
                        trackInput.transition = state;
                    }

                    $rootScope.$broadcast('trackInput', trackInput);
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-tracking/dist/directive.js
// module id = ./components/xo-tracking/dist/directive.js
// module chunks = 1